import { render, staticRenderFns } from "./BunchesDetails.vue?vue&type=template&id=c7c25e5e&"
import script from "./BunchesDetails.vue?vue&type=script&lang=js&"
export * from "./BunchesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports